import { createFileRoute } from '@tanstack/react-router';
import { HealthPage } from '../screens/admin/HealthPage';

export const Route = createFileRoute('/admin/health')({
  component: HealthPage,
});
